module.exports = __webpack_public_path__ + "static/soehne-web-halbfett-8cff1a6d93322e8756dbc46b381bac5d.woff2";